/* ao-ts-rating — echte Trusted-Shops-Bewertung in die Vertrauensleiste (30.08.2026)
 *
 * WARUM
 * In der Leiste stand die Zahl fest im Template. Sie war zuletzt „4,92 von 5" und
 * damit schlicht falsch — der echte Wert lag bei 4,93. Eine Zahl, die von Hand
 * gepflegt werden muss, wird irgendwann falsch; hier holt sie sich die Seite selbst.
 *
 * WELCHE ZAHL
 * Der Feed liefert fünf Zeiträume. Trusted Shops zeigt im eigenen Widget die Note
 * der letzten 365 Tage zusammen mit der Gesamtzahl aller Bewertungen — geprüft am
 * 30.08.: Widget „4,93 · 3.564", Feed 365days.rating = 4.93, overall.count = 3564.
 * Diese Kombination wird hier nachgebildet, damit Leiste und Widget nicht zwei
 * verschiedene Zahlen zeigen.
 *
 * AUSFALLVERHALTEN
 * Bis die Daten da sind (und falls sie nie kommen), steht die im Theme-Editor
 * gepflegte Beschriftung. Der Ausfallmodus ist damit „keine Zahl", nie „falsche
 * Zahl" — bei einer Werbeaussage der wichtigere der beiden Fälle.
 */
(function () {
  'use strict';

  var BASIS = 'https://integrations.etrusted.com/feeds/grades/v1/channels/';

  function punkteFuellen(behaelter, note) {
    var punkte = behaelter.querySelectorAll('[data-punkt]');
    for (var i = 0; i < punkte.length; i++) {
      var anteil = Math.max(0, Math.min(1, note - i));   // 0 bis 1 je Punkt
      var p = punkte[i];
      if (anteil >= 0.999) {
        p.style.background = 'var(--ao-brand)';
      } else if (anteil <= 0.001) {
        p.style.background = 'var(--ao-line-warm)';
      } else {
        var pct = Math.round(anteil * 100);
        p.style.background =
          'linear-gradient(90deg, var(--ao-brand) ' + pct + '%, var(--ao-line-warm) ' + pct + '%)';
      }
    }
  }

  function zahl(n) {
    return n.toLocaleString('de-DE');
  }

  function eintragen(el, note, anzahl) {
    var text = el.querySelector('[data-ao-tsrating-text]');
    var punkte = el.querySelector('[data-ao-tsrating-punkte]');
    if (punkte) punkteFuellen(punkte, note);
    if (text) {
      /* Wortlaut ist am Element einstellbar (30.08.2026). Auf der PRODUKTseite muss aus
         der Zeile unmissverständlich hervorgehen, dass es SHOP-Bewertungen sind — Sterne
         direkt unter einem Produkttitel sind sonst die kanonische Position für
         Produktbewertungen und würden falsch gelesen. Die Zeile wird deshalb nie auf
         „4,93" verkürzt, auch nicht responsiv. */
      var wort = el.getAttribute('data-wortlaut') || 'Bewertungen';
      text.textContent =
        note.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
        ' von 5 · ' + zahl(anzahl) + ' ' + wort;
    }
    el.setAttribute('data-ao-tsrating-geladen', 'true');
  }

  function laden(el) {
    var kanal = el.getAttribute('data-kanal');
    if (!kanal) return;
    fetch(BASIS + kanal + '/touchpoints/all/feed.json', { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) {
        var g = d && d.grades;
        if (!g) return;
        // 365 Tage für die Note, Gesamtzahl für die Menge — wie im TS-Widget.
        var note = g['365days'] && g['365days'].rating;
        var anzahl = g.overall && g.overall.count;
        // Fällt einer der beiden aus, lieber gar nichts anfassen als halb.
        if (typeof note !== 'number' || typeof anzahl !== 'number') return;
        eintragen(el, note, anzahl);
      })
      .catch(function () {
        /* Beschriftung aus dem Editor bleibt stehen. Bewusst still: ein roter
           Konsolenfehler für eine kosmetische Angabe hilft niemandem. */
      });
  }

  function start() {
    var alle = document.querySelectorAll('[data-ao-tsrating]:not([data-ao-tsrating-geladen])');
    for (var i = 0; i < alle.length; i++) laden(alle[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Der Theme-Editor baut Sektionen neu auf, ohne die Seite zu laden.
  document.addEventListener('shopify:section:load', start);
})();
